import { Injectable } from '@angular/core';
import { PreEnrollmentMemberModel } from 'src/app/shared/models/preEnrollment/members/preEnrollment-member.model';
import { BackendService } from 'src/app/shared/services/backend.service';

@Injectable({
  providedIn: 'root',
})
export class HRService {
  constructor(private readonly backendService: BackendService) {}

  async getPolicies(): Promise<any> {
    return new Promise(async resolve => {
      const policy = await this.backendService.get(`member/my/policies`);
      resolve(policy);
    });
  }

  public async getMembers(policyId: number): Promise<PreEnrollmentMemberModel[]> {
    return await this.backendService.get('preenrollment/' + policyId + '/preenrollmentmember');
  }
}
